import React from 'react'
import { useInstantSearch } from 'react-instantsearch-hooks-web'
import { Chip, Icon } from '../ui'
import { RefinementListProps } from './refinementList'

type RefinementClearProps = {
  attributes: RefinementListProps[]
}

const RefinementClear: React.FC<RefinementClearProps> = ({ attributes }) => {
  const { indexUiState, setIndexUiState } = useInstantSearch()
  const { refinementList, numericMenu } = indexUiState

  if (!refinementList && !numericMenu) {
    return null
  }

  const clearAttribute = ({
    attribute,
    value,
  }: {
    attribute: string
    value: string
  }) => {
    if (!indexUiState.refinementList) {
      return
    }

    const newState = {
      refinementList: {},
      ...indexUiState,
    }
    newState.refinementList[attribute] = indexUiState.refinementList[
      attribute
    ].filter((v) => v !== value)
    setIndexUiState(newState)
  }

  const clearNumericMenu = ({ attribute }: { attribute: string }) => {
    if (!indexUiState.numericMenu) {
      return
    }
    const newState = {
      numericMenu: {},
      ...indexUiState,
    }
    delete newState.numericMenu[attribute]
    setIndexUiState(newState)
  }

  return (
    <div className="flex-row flex-wrap items-center hidden gap-2 lg:flex empty:hidden">
      {refinementList &&
        attributes.map(({ attribute, transformLabel }) => {
          if (refinementList[attribute]) {
            return (
              <React.Fragment key={attribute}>
                {refinementList[attribute]?.map((value) => {
                  const chipName = getChipName({ value, transformLabel })
                  return (
                    <Chip
                      key={`${attribute}-${value}`}
                      label={chipName}
                      onClose={() => {
                        clearAttribute({ attribute, value })
                      }}
                    />
                  )
                })}
              </React.Fragment>
            )
          }

          return null
        })}

      {numericMenu &&
        attributes.map(({ attribute, transformLabel }) => {
          if (numericMenu[attribute]) {
            const value = numericMenu[attribute].replace(':', '')
            return (
              <React.Fragment key={attribute}>
                <Chip
                  key={`${attribute}`}
                  label={transformLabel ? transformLabel(value) : attribute}
                  onClose={() => {
                    clearNumericMenu({ attribute })
                  }}
                />
              </React.Fragment>
            )
          }

          return null
        })}

      {[...Object.keys(refinementList || {}), ...Object.keys(numericMenu || {})]
        .length > 0 && (
        <button
          type="button"
          className="flex flex-row items-center flex-nowrap"
          onClick={() =>
            setIndexUiState({
              ...indexUiState,
              refinementList: {},
              numericMenu: {},
            })
          }
        >
          <Icon icon="close" className="w-4 h-4" color="primary" />
          <span className="text-sm font-medium underline">Tout supprimer</span>
        </button>
      )}
    </div>
  )
}

function getChipName({
  value,
  transformLabel,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any
  // eslint-disable-next-line no-shadow, no-unused-vars, @typescript-eslint/no-explicit-any
  transformLabel?: (value: any) => string
}) {
  if (transformLabel) {
    const label = transformLabel(value)
    return label || value
  }
  return value
}

export default RefinementClear
